import React from 'react'

function MisiBaznas() {
  return (
    <div  className='pt-14  mb-14'>
    <h1 className='text-3xl font-bold text-primary pb-2 mb-1 border-b-2 border-b-orange-400'>MISI BAZNAS</h1>
    <p className='text-justify -w-full py-4 border-b-2 border-b-orange-400 '>1. Menjadi Badan Amil Zakat yang Profesional, Amanah, Menebar manfaat, Menabur Rahmat serta Memuzakkikan Mustahiq</p>
    <p className='text-justify w-full py-4 border-b-2 border-b-orange-400 '>2. Memberikan Pelayanan dan Bimbingan yang terbaik terhadap Muzakki dan Mustahiq;</p>
    <p className='text-justify w-full py-4 border-b-2 border-b-orange-400 '>3. Melaksanakan kegiatan dengan keterbukaan, kejujuran, tanggungjawab dan berpegang teguh pada ketentuan syari’at.</p>
</div>
  )
}

export default MisiBaznas